/*----------------------
  Function for convert . to ,
 ----------------------*/
 function number_format (number, decimals, dec_point, thousands_sep) {
  var n = number, prec = decimals;

  var toFixedFix = function (n,prec) {
      var k = Math.pow(10,prec);
      return (Math.round(n*k)/k).toString();
  };

  n = !isFinite(+n) ? 0 : +n;
  prec = !isFinite(+prec) ? 0 : Math.abs(prec);
  var sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep;
  var dec = (typeof dec_point === 'undefined') ? '.' : dec_point;

  var s = (prec > 0) ? toFixedFix(n, prec) : toFixedFix(Math.round(n), prec);
  // Fix for Internet Explorer parseFloat(0.55).toFixed(0) = 0;

  var abs = toFixedFix(Math.abs(n), prec);
  var _, i;

  if (abs >= 1000) {
      _ = abs.split(/\D/);
      i = _[0].length % 3 || 3;

      _[0] = s.slice(0,i + (n < 0)) +
             _[0].slice(i).replace(/(\d{3})/g, sep+'$1');
      s = _.join(dec);
  } else {
      s = s.replace('.', dec);
  }

  var decPos = s.indexOf(dec);
  if (prec >= 1 && decPos !== -1 && (s.length-decPos-1) < prec) {
      s += new Array(prec-(s.length-decPos-1)).join(0)+'0';
  }
  else if (prec >= 1 && decPos === -1) {
      s += dec+new Array(prec).join(0)+'0';
  }
  return s;
}


/*--------------------------------------
SLIDER QUICKVIEW
 --------------------------------------*/
SliderQuickview = {
  init: function () {
    var swiper = new Swiper(".swiper-quickview", {
      nextButton: '#slider-button-prev',
      prevButton: '#slider-button-next',
      navigation: {
        nextEl: ".slider-button-next",
        prevEl: ".slider-button-prev",
      }
    });

  }

};

/*--------------------------------------
POPUP QUICK VIEW
 --------------------------------------*/
PopUpQuikView = {
  init: function () {
    $(".btn-quick-view").click(function () {
      $("body").addClass("body-quickview-open");
      $(".quickview").addClass("quickview-open");
      var id = $(this).data("id");
      
      var json = JSON.parse ($(this).parent().parent().find('script[type="application/json"]').text());
      var variants = JSON.parse ($(this).parent().parent().find('.productvariation').text());
      BuyQuickView.currentProduct = variants; // copy data to QuickView
      //console.table(json);
      //console.table(variants);
      $('.swiper-quickview .swiper-wrapper').html('');
      $('.quickview__title').html(json['title']);
      $('.quickview__subtitle').html($(this).data('subtitulo'));
      $('.quickview__description').html(json['description']);
      $('.quickview__moreinfo').attr("href", "/products/"+json['handle']);



      var quickvariants = $('.product-variants-id-'+id).html();
      
	      $('.quickview__content__info__text__variables').html(quickvariants);
      
      
      let price = json.price/100;
      price  = number_format(price, 2, ',', '.')+' €';
      if (json.compare_at_price>0){
        let compare_at_price = json.compare_at_price/100;
        compare_at_price  = number_format(compare_at_price, 2, ',', '.')+' €';
        price = price +'<span class="color-grey collection__price-sale">'+compare_at_price+'</span>';
      }
      $('.quickview__price').html(price);
      for (const img of json.images) { // for each image
        $('.swiper-quickview .swiper-wrapper').append('<div class="swiper-slide"><img src="'+img+'" alt="" height="" width="" loading="lazy"></div>');
    }
    if (variants.length){
      $('input[name="idquickview"]').val(variants[0]['id']);
      }else
      $('input[name="idquickview"]').val(json['id']);
      }

    );

    $(".btn-close").click(function () {
      $(".quickview").removeClass("quickview-open");
      $("body").removeClass("body-quickview-open");

    });
    $("body").click(function (event) {
      if (!$(event.target).closest('.btn-quick-view, .quickview').length) {
        $(".quickview").removeClass("quickview-open");
        $("body").removeClass("body-quickview-open");
        
      }
    });


  }

};

/*--------------------------------------
POPUP QUICK VIEW
 --------------------------------------*/
 BuyQuickView = {
  currentProduct:'',
  init: function () {
    $(".btn-quick-buynow").click(function (e) {
      e.preventDefault();
      console.log('buy now');
      BuyQuickView.buynow();

    });
    $(".btn-quick-addtocart").click(function (e) {
      e.preventDefault();
      console.log('buy addtocart');
      BuyQuickView.addToCart();
    });

    // change options    
    $(document).on('click','.input-variant-quickview',function(){ // pick event from the document -> i can trigger element loaded by ajax
      //console.log ('click variant ' + $(this).val());
      var option1 = $(this).val();
      BuyQuickView.currentProduct.forEach( function(valor, indice, array) { // search option1
        
        if (array[indice]['option1']== option1)  {
          console.table (array[indice]);
          $("input[name='idquickview']").val(array[indice]['id']);
          if (array[indice]['price'] > 0){
            var price =array[indice]['price']/100;
          }else{
            var price =0;
          }
          price  = number_format(price, 2, ',', '.')+' €';
          $(".quickview__price").html(price);
        // its available ?
        if (array[indice]['available']==false) {
          $('.quickview__bottom').addClass('soldout');
          }else{
          $('.quickview__bottom').removeClass('soldout');
        }
        
        }
    });


    });


  },
  buynow: function() {
    
    let id = $('input[name="idquickview"]').val();
    let qty = $('input[name="quantity"]').val();
    
    data = {
        "id": id,
        "quantity": qty
      }
      console.table (data);
      
    $.ajax({
       type: 'POST', 
       url: '/cart/add.js',
       dataType: 'json', 
       data:  data,
       success: BuyQuickView.buynowOk,
       error: BuyQuickView.addToCartFail
     });
    },
    buynowOk: function(){
        // redirect to checkout      
        
        window.location.href = "/cart";
    },
    addToCart: function() {
    
      let id = $('input[name="idquickview"]').val();
      let qty = $('input[name="quantity"]').val();
      
      data = {
          "id": id,
          "quantity": qty
        }
        //console.table (data);
        
      $.ajax({
         type: 'POST', 
         url: '/cart/add.js',
         dataType: 'json', 
         data:  data,
         success: BuyQuickView.addToCartOk,
         error: BuyQuickView.addToCartFail
       });
      },
    addToCartOk: function(){
      BuyQuickView.updateCart();
      // Popup open ! 
      $(".quickview").removeClass("quickview-open");  
      $("body").removeClass("body-quickview-open");
      
    },
    updateCart: function(){
      $.getJSON('/cart.js', function(cart) {
        var v = cart.item_count;
        //console.log(v);
        if (v>0) {
          $('.cartcount').text(v); // show new up qty
          $('.cartcount').removeClass("no-visible");
        } else {
          $('.cartcount').text(v); // show new up qty
          $('.cartcount').removeClass("no-visible");
            }
          });
    },

};




$(function () {
  SliderQuickview.init();
  PopUpQuikView.init();
  BuyQuickView.init();

  if ($(window).width() >= 1920) {
    $(".quickview .accordion-wrapper #quickview0").attr( 'checked', true ); 
  }
});